if (!customElements.get('lac-wrap-addons')) {
  customElements.define('lac-wrap-addons', class extends HTMLElement {
    connectedCallback() {
      this.form = document.getElementById(this.dataset.formId);
      if (!this.form || this.controller) return;
      this.controller = new AbortController();
      this.prices = JSON.parse(this.dataset.prices);
      this.money = new Intl.NumberFormat(document.documentElement.lang || 'en', {style:'currency', currency:this.dataset.currency});
      this.addEventListener('change', event => {
        const row = event.target.closest('.lac-wrap-addons__row');
        if (row) this.updateRow(row, event.target.matches('select'));
        this.updateTotal();
      }, {signal:this.controller.signal});
      this.addEventListener('input', () => this.updateTotal(), {signal:this.controller.signal});
      this.form.addEventListener('input', () => this.updateTotal(), {signal:this.controller.signal});
      this.form.addEventListener('change', () => this.updateTotal(), {signal:this.controller.signal});
      if (typeof subscribe === 'function') {
        this.unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, event => {
          if (event.data.sectionId === this.dataset.sectionId) this.updateTotal();
        });
      }
      this.querySelectorAll('.lac-wrap-addons__row').forEach(row => this.updateRow(row, false));
      this.updateTotal();
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.controller = null;
      this.unsubscribe?.();
    }
    updateRow(row, reset) {
      const option = row.querySelector('select').selectedOptions[0];
      const quantity = row.querySelector('.lac-wrap-addons__quantity');
      quantity.disabled = !row.querySelector('input[type=checkbox]').checked;
      quantity.min = option.dataset.min || '1';
      quantity.step = option.dataset.step || '1';
      if (option.dataset.max) quantity.max = option.dataset.max;
      else quantity.removeAttribute('max');
      if (reset) quantity.value = quantity.min;
      row.querySelector('[data-addon-price]').textContent = this.money.format(Number(option.dataset.price) / 100);
      const compare = row.querySelector('[data-addon-compare]');
      compare.hidden = Number(option.dataset.compare) <= Number(option.dataset.price);
      compare.textContent = this.money.format(Number(option.dataset.compare) / 100);
    }
    selectedRows() {
      return Array.from(this.querySelectorAll('.lac-wrap-addons__row')).filter(row => row.querySelector('input[type=checkbox]').checked);
    }
    updateTotal() {
      const variant = this.prices.find(variant => String(variant.id) === this.form.elements.id.value);
      const quantity = Math.max(1, Number(this.form.elements.quantity?.value) || 1);
      let total = (variant?.price || 0) * quantity;
      this.selectedRows().forEach(row => {
        total += Number(row.querySelector('select').selectedOptions[0].dataset.price) * Math.max(0, Number(row.querySelector('.lac-wrap-addons__quantity').value) || 0);
      });
      this.querySelector('[data-addon-total]').textContent = this.money.format(total / 100);
      const dynamic = this.form.querySelector('.shopify-payment-button');
      if (dynamic) dynamic.hidden = this.selectedRows().length > 0;
    }
    validateSelection() {
      return this.selectedRows().every(row => row.querySelector('.lac-wrap-addons__quantity').reportValidity());
    }
    appendItems(data) {
      const rows = this.selectedRows();
      if (!rows.length) return;
      for (const [key,value] of Array.from(data.entries())) {
        if (key === 'id' || key === 'quantity' || key === 'selling_plan' || key.startsWith('properties[')) {
          const itemKey = key.startsWith('properties[') ? 'items[0][properties]' + key.slice(10) : 'items[0][' + key + ']';
          data.append(itemKey, value);
          data.delete(key);
        }
      }
      rows.forEach((row,index) => {
        data.append('items[' + (index + 1) + '][id]', row.querySelector('select').value);
        data.append('items[' + (index + 1) + '][quantity]', row.querySelector('.lac-wrap-addons__quantity').value);
      });
    }
  });
}
